import type { RouteRecordRaw } from 'vue-router'
import BrandList from '@/views/frontDesk/brand/list.vue'
import BrandIndex from '@/views/frontDesk/brand/index.vue'

// 品牌厂家
export const BrandRoute: Array<RouteRecordRaw> = [
  {
    path: 'brandIndex',
    name: 'BrandIndex',
    meta: {
      title: '品牌厂家' 
    },
    component: BrandIndex
  },
  {
    path: 'brandList',
    name: 'BrandList',
    meta: {
      title: '厂家列表' 
    },
    component: BrandList
  },
]

export default BrandRoute